

interface FormErrorProps {
    message?: string;
}

export const FormError: React.FC<FormErrorProps> = ({ message }) => {
    if (!message) return null;
    return (
        <div className="text-[#D33A2C] mt-[2px] text-[13px]">
            {message}
        </div>
    )
}